import { Application } from 'stimulus'
import { Controller } from 'stimulus'

class RegistroController extends Controller {
  static targets = ['inputNick', 'inputEmail', 'inputPwd']

  connect() {
    this.timer = {}
    this.timerChecker = 500
  }

  notifySet(input, error, color, message) {
    input.style.color = color
    input.style.borderColor = color
    error.style.color = color
    error.classList.remove('rnk-Icon-spinner-inline')
    error.innerHTML = message || ''
  }

  notify(success, input, error, color, message) {
    input.setCustomValidity(success ? '' : message + '.')
    this.notifySet(input, error, color, message)
  }

  notifyWait(options) {
    this.input = options.chequeaAjaxOptions.input
    this.error = options.chequeaAjaxOptions.error

    this.error.classList.add('rnk-Icon-spinner-inline')
    this.error.innerHTML = '&nbspComprobando...'
    this.error.style.color = 'inherit'
  }

  notifyError(input, error, message) {
    this.notify(false, input, error, '#da4a33', message)
  }

  notifySuccess(input, error, message) {
    if (input.checkValidity() && input.type === 'email') {
      this.notifySet(input, error, '')
    } else {
      this.notify(true, input, error, '#0d7f09', message)
    }
  }

  chequeaAjax(options) {
    fetch(options.url, { credentials: 'same-origin' })
      .then(response => {
        const status = response.status

        response.json().then(body => {
          if (response.ok) {
            this.notifySuccess(options.input, options.error, body.message)
          } else {
            this.notifyError(options.input, options.error, body['full_message'] || body.message)
          }
        })
      })
  }

  chequeando(options, field) {
    this.notifyWait(options)
    clearTimeout(this.timer[field])
    this.timer[field] = setTimeout(() => { this.chequeaAjax(options.chequeaAjaxOptions) }, this.timerChecker)
  }

  chequeaNick() {
    this.errorNick = this.inputNickTarget.nextElementSibling
    this.patternNick = this.inputNickTarget.pattern
    this.nickValido = new RegExp(this.patternNick).test(this.inputNickTarget.value)

    if (this.inputNickTarget.value.length < 5 || this.inputNickTarget.value.length > 20) {
      this.notifyError(this.inputNickTarget, this.errorNick, 'El nombre de usuario debe tener entre 5 y 20 caracteres')
    } else if (!this.nickValido) {
      this.notifyError(this.inputNickTarget, this.errorNick, 'El nombre de usuario no debe contener caracteres especiales')
    } else {
      this.chequeando({
        chequeaAjaxOptions: {
          url: '/usuario/comprueba-nick?nick=' + this.inputNickTarget.value,
          input: this.inputNickTarget,
          error: this.errorNick
        }
      }, 'nick')
    }
  }

  chequeaEmail() {
    this.errorEmail = this.inputEmailTarget.nextElementSibling
    this.patternEmail = this.inputEmailTarget.pattern
    this.emailValido = new RegExp(this.patternEmail).test(this.inputEmailTarget.value)

    if (!this.emailValido) {
      this.notifyError(this.inputEmailTarget, this.errorEmail, this.inputEmailTarget.dataset.errormsg)
    } else {
      this.chequeando({
        error: this.errorEmail,
        chequeaAjaxOptions: {
          url: '/usuario/comprueba-email?email='+ encodeURIComponent(this.inputEmailTarget.value),
          input: this.inputEmailTarget,
          error: this.errorEmail
        }
      }, 'email')
    }
  }

  chequeaPwd() {
    this.errorPwd = this.inputPwdTarget.nextElementSibling

    if (this.inputPwdTarget.value.length < 5 || this.inputPwdTarget.value.length > 200) {
      this.notifyError(this.inputPwdTarget, this.errorPwd, 'La contraseña debe tener entre 5 y 200 caracteres')
    } else {
      this.notifySuccess(this.inputPwdTarget, this.errorPwd, '')
    }
  }
}

const application = Application.start()
application.register('registro', RegistroController)
